// material-ui
import { TypographyVariantsOptions } from '@mui/material/styles';

// types
import { FontFamily } from 'types/config';

// ==============================|| DEFAULT THEME - TYPOGRAPHY  ||============================== //

const Typography = (fontFamily: FontFamily): TypographyVariantsOptions => ({
  htmlFontSize: 16,
  fontFamily,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  h1: {
    fontWeight: 600,
    fontSize: '72px',
    lineHeight: '86px'
  },
  h2: {
    fontWeight: 600,
    fontSize: '66px',
    lineHeight: '84px'
  },
  h3: {
    fontWeight: 600,
    fontSize: '56px',
    lineHeight: '72px'
  },
  h4: {
    fontWeight: 600,
    fontSize: '48px',
    lineHeight: '60px'
  },
  h5: {
    fontWeight: 600,
    fontSize: '40px',
    lineHeight: '52px'
  },
  h6: {
    fontWeight: 400,
    fontSize: '32px',
    lineHeight: '40px'
  },
  caption: {
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 1.66
  },
  body1: {
    fontSize: '0.875rem',
    lineHeight: 1.57
  },
  body2: {
    fontSize: '0.75rem',
    lineHeight: 1.66
  },
  subtitle1: {
    fontSize: '0.875rem',
    fontWeight: 600,
    lineHeight: 1.57
  },
  subtitle2: {
    fontSize: '0.75rem',
    fontWeight: 500,
    lineHeight: 1.66
  },
  overline: {
    lineHeight: 1.66
  },
  button: {
    textTransform: 'capitalize'
  }
});

export default Typography;
